import { Button } from '@/components/atoms/Button';
import LivescoreH2HDetails from '@/components/molecules/LivescoreH2HDetails/LivescoreH2HDetails';
import LivescoreMatchDetails from '@/components/molecules/LivescoreMatchDetails/LivescoreMatchDetails';
import LivescoreMatchRaport from '@/components/molecules/LivescoreMatchReport/LivescoreMatchRaport';
import LivescoreMatchStatistics from '@/components/molecules/LivescoreMatchStatistics/LivescoreMatchStatistics';
import LivescoreSeasonTable from '@/components/molecules/LivescoreSeasonTable/LivescoreSeasonTable';
import LivescoreFormationDetails from '@/components/molecules/LivesoreFormationDetails/LivescoreFormationDetails';
import { PREMATCH_STATUSES, useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { LivescoreSeasonTableProvider } from '@/context/LivescoreSeasonTableContext';
import { cn } from '@/utils/cn';
import { useMemo, useState } from 'react';

const PREMATCH_FILTER_BUTTONS = [
  {
    label: 'Szczegóły',
    id: 'details',
  },
  {
    label: 'Składy',
    id: 'lineups',
  },
  // {
  //   label: 'Kursy',
  //   id: 'odds',
  // },
  {
    label: 'H2H',
    id: 'h2h',
  },
  {
    label: 'Tabela',
    id: 'table',
  },
] as const;

const FILTER_BUTTONS = [
  {
    label: 'Relacja na żywo',
    id: 'live',
  },
  {
    label: 'Statystyki',
    id: 'stats',
  },
  {
    label: 'Składy',
    id: 'lineups',
  },
  // {
  //   label: 'Kursy',
  //   id: 'odds',
  // },
  {
    label: 'h2h',
    id: 'h2h',
  },
  {
    label: 'Tabela',
    id: 'table',
  },
] as const;

type Filter = (typeof FILTER_BUTTONS)[number]['id'] | (typeof PREMATCH_FILTER_BUTTONS)[number]['id'];

const LivescoreMatchContent = () => {
  const { match } = useLivescoreMatch();

  const [filter, setFilter] = useState<Filter>(
    PREMATCH_STATUSES.includes(match?.sport_event_status?.status ?? '')
      ? PREMATCH_FILTER_BUTTONS[0]['id']
      : FILTER_BUTTONS[0]['id'],
  );
  0;

  const LivescoreMatchContentSwitch = useMemo(() => {
    if (PREMATCH_STATUSES.includes(match.sport_event_status.status)) {
      switch (filter as (typeof PREMATCH_FILTER_BUTTONS)[number]['id']) {
        case 'details':
          return <LivescoreMatchDetails />;
        case 'lineups':
          return <LivescoreFormationDetails />;
        // case 'odds':
        //   return <div>Kursy</div>;
        case 'h2h':
          return <LivescoreH2HDetails />;
        case 'table':
          return <LivescoreSeasonTable />;
        default:
          return null;
      }
    } else {
      switch (filter as (typeof FILTER_BUTTONS)[number]['id']) {
        case 'live':
          return <LivescoreMatchRaport />;
        case 'stats':
          return <LivescoreMatchStatistics />;
        case 'lineups':
          return <LivescoreFormationDetails />;
        // case 'odds':
        //   return <div>Kursy</div>;
        case 'h2h':
          return <LivescoreH2HDetails />;
        case 'table':
          return (
            <LivescoreSeasonTable
              score={
                match.sport_event_status.status === 'live'
                  ? {
                      home: {
                        id: match.sport_event.competitors.find((c) => c.qualifier === 'home')?.id ?? '',
                        score: match.sport_event_status.home_score,
                      },
                      away: {
                        id: match.sport_event.competitors.find((c) => c.qualifier === 'away')?.id ?? '',
                        score: match.sport_event_status.away_score,
                      },
                    }
                  : undefined
              }
            />
          );
        default:
          return null;
      }
    }
  }, [filter]);

  return (
    <div>
      <div className="relative mb-4 mt-1">
        <ul
          className={cn(
            'list-none pl-0 flex flex-row gap-2 sm:w-fit w-full sm:overflow-x-auto overflow-x-scroll rounded-lg',
          )}
        >
          {(PREMATCH_STATUSES.includes(match.sport_event_status.status) ? PREMATCH_FILTER_BUTTONS : FILTER_BUTTONS).map(
            ({ label, id }) => (
              <li>
                <Button
                  key={id}
                  variant="primaryGlass"
                  type="button"
                  className={cn(
                    'uppercase sm:text-[11px] text-[8px] !text-primary-600 py-2 px-4 w-max',
                    filter === id && '!bg-primary-600 dark:!text-black-500 !text-white',
                  )}
                  onClick={() => {
                    setFilter(id);
                  }}
                >
                  <span className="line-clamp-1 overflow-ellipsis">{label}</span>
                </Button>
              </li>
            ),
          )}
        </ul>
      </div>
      {/* This provider is required as it prevents for refetching season table */}
      <LivescoreSeasonTableProvider seasonId={match.sport_event.sport_event_context.season.id}>
        {LivescoreMatchContentSwitch}
      </LivescoreSeasonTableProvider>
    </div>
  );
};

export default LivescoreMatchContent;
